import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DataTable } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { ProgressBar } from '../components/ProgressBar';
import { activeScans } from '../data/mockData';
import { StopCircle, Plus } from 'lucide-react';
import { toast } from 'sonner';

export default function ActiveScans() {
  const navigate = useNavigate();
  
  const handleStop = (scan) => {
    toast.success(`Scan ${scan.id} stopped successfully`);
  };

  const columns = [
    { key: 'id', label: 'Scan ID' },
    { key: 'target', label: 'Target' },
    { key: 'type', label: 'Type' },
    { 
      key: 'progress', 
      label: 'Progress',
      render: (row) => <ProgressBar progress={row.progress} />
    },
    { 
      key: 'risk', 
      label: 'Risk',
      render: (row) => <StatusBadge severity={row.risk} />
    },
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <button 
          className="action-btn btn-danger"
          onClick={() => handleStop(row)}
          data-testid={`stop-scan-${row.id}`}
        >
          <StopCircle size={16} />
          <span>Stop</span>
        </button>
      )
    }
  ];

  return (
    <div className="page-container" data-testid="active-scans-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Active Scans</h1>
          <p className="page-subtitle">Monitor live security scans</p>
        </div>
        <button 
          className="btn-primary"
          onClick={() => navigate('/new-scan')}
          data-testid="new-scan-button"
        >
          <Plus size={18} />
          <span>New Scan</span>
        </button>
      </div>

      <DataTable 
        columns={columns} 
        data={activeScans}
        emptyMessage="No active scans"
      />
    </div>
  );
}
